define('Components/BannerComeInWidget/js/views/BannerComeInWidgetInstanceView',[
    'jquery',
    'WidgetInstanceView',
    'app',
    'template!Components/BannerComeInWidget/templates/bannerComeIn',
    'InternalLinkView',
    'router'
],
    function($, WidgetInstanceView, app, template, InternalLinkView, router){
        var activeSlide = 0,
            touchstartX = 0,
            touchendX = 0;
        return WidgetInstanceView.extend({
            name: 'BannerComeInWidgetInstanceView',
            events: {
                'click .banner-comeIn__button' : 'changeSlide',
                'click .banner-comeIn__item' : 'onClick'
            },

            afterRender:function(){
                var view = this,
                    wrapper = view.$('.banner-comeIn__wrapper');
                if (app.isMobile()) {
                    wrapper.on('touchstart',function(event){
                        touchstartX = event.originalEvent.changedTouches[0].screenX;
                    });
                    wrapper.on('touchend',function(event){
                        touchendX = event.originalEvent.changedTouches[0].screenX;
                        view.handleGesture();
                    });
                }
            },

            onClick:function(e) {
                var currentTarget = $(e.currentTarget),
                    link = currentTarget.find('a'),
                    href = link.attr("href");

                if (!app.isMobile()) {
                    router.go(href)
                };
            },

            handleGesture:function(){
                var tolerance = 25
                if (touchendX + tolerance < touchstartX ) {
                    activeSlide = 1;
                    this.changeSlide();
                }
                if (touchendX - tolerance > touchstartX) {
                    activeSlide = 0;
                    this.changeSlide();
                }
            },

            getTemplate:function () {
                return template
            },

            changeSlide:function(e) {
                var view = this,
                    wrapper = view.$('.banner-comeIn__wrapper');
                    if (e) {
                        e.preventDefault()
                        var currentTarget = $(e.currentTarget),
                        i = currentTarget.data('value');
                        activeSlide = i;
                    }
                view.$('.banner-comeIn__button.active').removeClass('active');
                $(view.$('.banner-comeIn__button')[activeSlide]).addClass('active');
                wrapper.css('transform', 'translate(calc(-' + activeSlide * 60 + 'vw - '+ activeSlide * 40 +'px)')
            }
        })
    }
);
